import { combineReducers } from 'redux';

import answerQuestionsReducer from './answerQuestionsReducer';
import authReducer from './authReducer';
import fastTrackReducer from './fastTrackReducer';
import findSimilarReducer from './findSimilarReducer';
import globalEventReducer from './globalEventReducer';
import asyncJobReducer from './asyncJobReducer';
import modelReducer from './modelReducer';
import onlyOfficeReducer from './onlyOfficeReducer';
import playbookBuilderReducer from './playbookBuilderReducer';
import poaReducer from './poaReducer';
import questionBuilderReducer from './questionBuilderReducer';
import ruleReducer from './ruleReducer';
import snackbarReducer from './snackbarReducer';
import userFlowReducer from './userflowReducer';

const combinedReducers = combineReducers({
  Model: modelReducer,
  PlaybookBuilder: playbookBuilderReducer,
  QuestionBuilder: questionBuilderReducer,
  AnswerQuestions: answerQuestionsReducer,
  POA: poaReducer,
  Rule: ruleReducer,
  FastTrack: fastTrackReducer,
  OnlyOffice: onlyOfficeReducer,
  FindSimilar: findSimilarReducer,
  UserFlow: userFlowReducer,
  Snackbar: snackbarReducer,
  GlobalEvent: globalEventReducer,
  Auth: authReducer,
  AsyncJob: asyncJobReducer,
});

export default combinedReducers;
